const trimTrailingSlash = (url) => (url ? url.replace(/\/+$/, "") : "");

export const API_BASE_URL = trimTrailingSlash(process.env.VUE_APP_API_BASE_URL || "");
export const STORAGE_BASE_URL = trimTrailingSlash(
  process.env.VUE_APP_STORAGE_BASE_URL || API_BASE_URL
);
